import template from './scriptsList.template.html';

export default {
  template,
  bindings: {
    scripts: '=',
    onClick: '&',
    onChange: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $filter, $mdMedia, listService) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.list = listService;
      ctrl.list.clear();

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.list.setData(
          $filter('stStartingLetter')(ctrl.scripts, ctrl.list.getGroupingByFirstLetter())
        );
        ctrl.onReady({ list: ctrl.list });
      };
      this.click = function ($event, data) {
        ctrl.onClick({ event: $event, data: data });
      };
      this.select = function (data) {
        var isSelected = ctrl.list.setSelected(data);
        ctrl.onChange({ list: ctrl.list, data: data, isSelected: isSelected });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {
        if (changes.scripts && changes.scripts.currentValue) {
          ctrl.initialize();
        }
      };
    }
  }
};
